import template from "./organizations-settings-page.html";

const OrganizationSettingsPageComponent = {
  template: template,
  controller: class OrganizationSettingsPageController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $filter,
      OrganizationService,
      Notification,
      FilePicker
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$filter = $filter;
      this.FilePicker = FilePicker;
      this.OrganizationService = OrganizationService;
      this.NotificationService = Notification;
    }

    $onInit() {
      this.organization = this.$rootScope.organization;
      this.user = this.$rootScope.user;
      this.baseUrl = process.env.CLIENT_URL;

      this.$rootScope.$on("refreshOrganization", () => {
        this.organization = this.$rootScope.organization;
      });
    }

    async uploadLogo() {
      const imageMetadata = await this.FilePicker.uploadOrganizationImage();
      if (imageMetadata) {
        await this.OrganizationService.updateMetadataLogo(imageMetadata);
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")(
            "notificationService.message.imageSaved"
          ),
        });
        this.$rootScope.$applyAsync();
      }
    }

    goCustomDomain() {
      this.$state.go("app.organization.customDomain");
    }
  },
};

export default OrganizationSettingsPageComponent;
